import { mdiClose, mdiFileRemoveOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { Col, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';
import './DeleteRole.scss';
import { toast } from 'react-toastify';

function DeleteRole({ isOpen, toggle, role }) {
  const handleDelete = () => {
    toggle();
    toast.success('Role deleted successfully', {
      className: 'toast-success',
    });
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <ModalBody>
        <div className="d-flex flex-row align-items-center justify-content-between mb-3">
          <div className="delete-role-cancel-icon">
            <Icon path={mdiFileRemoveOutline} size={0.7} />
          </div>
          <div>
            <button type="button" className="btn btn-link p-0" onClick={toggle}>
              <Icon path={mdiClose} size={1} />
            </button>
          </div>
        </div>
        <div>
          <h5>Confirmation</h5>
          <p>Are you sure you want to delete the {role} role?</p>
        </div>
        <Label>
          Reason<span className="text-danger">*</span>
        </Label>
        <Input placeholder="Enter" type="textarea" rows="4" />
      </ModalBody>
      <ModalFooter>
        <Col>
          <button
            type="button"
            onClick={toggle}
            className="custom-light-btn w-100"
          >
            No
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="custom-danger-btn w-100"
            onClick={handleDelete}
          >
            Yes, Delete
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteRole;
